import React from 'react'
import SEO from "../common/SEO";
import HeaderTwo from '../common/header/HeaderTwo';
import FooterTwo from '../common/footer/FooterTwo';
import Copyright from '../common/footer/Copyright';
import { Link } from "react-router-dom";
import MemberBios from "../elements/service/MemberBios";
import { useTranslation } from "react-i18next";

const AdvisoryTeam = () => {
    const { t } = useTranslation('enterprise');
    return (
        <>
            <SEO title="N01ZET Team - l'équipe N01ZET - Victor DEGBO - Valérie CAILLAUD - Marie-Héléne MORVAN - Anne-Marie CALMEIL - Philippe BOISDELET - Guy ROULLIER - Hugues FEYRIT - Gustavo HORNOS" />
            <main className="page-wrapper">
                <HeaderTwo btnStyle="btn-small btn-icon" HeaderSTyle="header-transparent" />

                {/*  Start Advisory Team  */}
                <div className="rn-service-area rn-section-gap member-display">
                    <div className="container">
                        <div className="row pb-5 mb-5 bios-title-header">
                            <div className="col-lg-12 text-center">
                            <h2 className='title'>{t('WhoAreWe.advisoryTeam')}</h2>
                            </div>
                        </div>
                        <MemberBios
                        image = "/images/team/advisory1.png"
                        link = "https://www.linkedin.com/in/laurentsachs/"
                        title = "Laurent Sachs"
                        description = {t('adv.function.lau')}
                        text1 = {t('adv.lau.text1')}
                        text2 = {t('adv.lau.text2')}
                        text3 = {t('adv.lau.text3')}
                        />
                    </div>
                </div>

                {/* Start Member4 */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <MemberBios
                        image = "/images/team/advisory4.png"
                        link = "https://www.linkedin.com/in/philippe-paban/"
                        title = "Philippe Paban"
                        description = {t('adv.function.phi')}
                        text1 = {t('adv.phi.text1')}
                        text2 = {t('adv.phi.text2')}
                        text3 = {t('adv.phi.text3')}
                        />
                    </div>
                </div>
                {/* End Member4 */}

                {/* Start Member5 */}
                <div className="rn-service-area rn-section-gap member-display">
                    <div className="container">
                        <MemberBios
                        image = "/images/team/advisory5.png"
                        link = "https://www.linkedin.com/in/fadhel-b-76b0732/"
                        title = "Fadhel Ben Brahem"
                        description = {t('adv.function.fad')}
                        text1 = {t('adv.fad.text1')}
                        text2 = {t('adv.fad.text2')}
                        text3 = {t('adv.fad.text3')}
                        />
                    </div>
                </div>
                {/* End Member5 */}

                {/* Start Member6 */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <MemberBios
                        image = "/images/team/advisory6.png"
                        link = "https://www.linkedin.com/in/hugues-feyrit-7b639923/"
                        title = "Hugues Feyrit"
                        description = {t('adv.function.hug')}
                        text1 = {t('adv.hug.text1')}
                        text2 = {t('adv.hug.text2')}
                        text3 = {t('adv.hug.text3')}
                        />
                    </div>
                </div>
                {/* End Member6 */}

                {/* Start Member7 */}
                <div className="rn-service-area rn-section-gap member-display">
                    <div className="container">
                        <MemberBios
                        image = "/images/team/advisory7.png"
                        link = "https://www.linkedin.com/in/ytevonian"
                        title = "Yves Tevonian"
                        description = {t('adv.function.yve')}
                        text1 = {t('adv.yve.text1')}
                        text2 = {t('adv.yve.text2')}
                        text3 = {t('adv.yve.text3')}
                        />
                    </div> 
                </div>
                {/* End Member7 */}

                {/* Start Member8 */}
                <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <MemberBios
                        image = "/images/team/advisory8.png"
                        link = "https://www.linkedin.com/in/pierreboscq/"
                        title = "Pierre Boscq"
                        description = {t('adv.function.pie')}
                        text1 = {t('adv.pie.text1')}
                        text2 = {t('adv.pie.text2')}
                        text3 = {t('adv.pie.text3')}
                        />
                    </div>
                </div>
                {/* End Member8 */}

                {/* Start Member9 */}
                <div className="rn-service-area rn-section-gap member-display">
                    <div className="container">
                        <MemberBios
                        image = "/images/team/advisory9.png"
                        link = "https://www.linkedin.com/in/gustavohornoshrexpert/"
                        title = "Gustavo Hornos Prados"
                        description = {t('adv.function.gus')}
                        text1 = {t('adv.gus.text1')}
                        text2 = {t('adv.gus.text2')}
                        text3 = {t('adv.gus.text3')}
                        />
                    </div>
                    <div className='text-center pt-5'>
                    <Link className="btn-default btn-large" to='/about-us'>{t('WhoAreWe.teamReturn')}</Link>
                    </div>  
                </div>
                {/* End Member9 */}
                 
                {/*  End Advisory Team  */}                    
                <FooterTwo />
                <Copyright />
            </main>
        </>
    )
}

export default AdvisoryTeam;
